import React from 'react';
import { motion } from 'framer-motion';
import { Button, scrollToPurchase } from './ui/Button';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-fil-beige px-4 sm:px-6 lg:px-8 py-12 sm:py-16" data-id="element-29" data-mp="av37exjcfd39">
      <div className="max-w-5xl mx-auto" data-id="element-30" data-mp="asz4oix6kk4k">
        <div className="text-center max-w-2xl mx-auto mb-10" data-id="element-31" data-mp="ftms6um7aiu1">
          <span className="inline-block bg-white text-fil-terra-dark text-[10px] sm:text-xs font-bold uppercase tracking-[0.14em] px-4 py-2 rounded-full mb-4" data-id="element-32" data-mp="fs3ftf3o0rxj">
            Además, solo por hoy
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-fil-text leading-tight" data-id="element-33" data-mp="5tnnx9wtdemz">
            Tres recursos adicionales sin costo extra
          </h2>
        </div>

        <div className="grid sm:grid-cols-3 gap-5 sm:gap-6" data-id="element-34" data-mp="3t2slmmbumco0">
          {bonuses.map((bonus, i) => <motion.article key={bonus.title} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: i * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white rounded-[1.75rem] p-5 sm:p-6 flex flex-col text-center" data-id="element-35" data-mp="1mb1krdlk0laa" data-mpi={i}>
              <img src={bonus.img} alt={`Portada del ${bonus.tag}: ${bonus.title}`} className="w-full max-w-[190px] mx-auto h-auto mb-5" data-id="element-36" data-mp="3r5ykz706m8q8" />
              <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-fil-terra mb-2" data-id="element-37" data-mp="2zfaldze5pbeo">
                {bonus.tag}
              </span>
              <h3 className="text-base sm:text-lg font-bold text-fil-text leading-tight mb-3" data-id="element-38" data-mp="2ui2749w4prip">
                {bonus.title}
              </h3>
              <p className="text-sm text-fil-text/70 leading-relaxed mt-auto" data-id="element-39" data-mp="33hfdgtoyhzz7">
                {bonus.desc}
              </p>
            </motion.article>)}
        </div>

        <div className="text-center mt-10" data-id="element-40" data-mp="ns4bqd4poebe">
          <p className="text-lg sm:text-xl font-serif font-bold text-fil-cocoa mb-6" data-id="element-41" data-mp="irgdb6e5kv75">
            Todo esto está incluido con un único acceso.
          </p>
          <Button onClick={scrollToPurchase} className="w-full sm:w-auto text-base px-10 py-5" data-id="element-42" data-mp="3cl0sr0zfy6g9">
            Quiero acceder al curso
          </Button>
        </div>
      </div>
    </section>;
}